module.exports = __webpack_public_path__ + "img/banner3_bg.7d89afd2.jpg";